import React, { useState, useEffect, useRef } from 'react';
import { Github } from 'lucide-react';
import PixelPortrait from './PixelPortrait';

/* ══════════════════ Contact · 终极融合版 ══════════════════
   已从 /redesign 复制版转正（原 ContactSectionRedesign，组件名还原）。
   电报纸骨架 × 像素拼合头像（C 布局：答题解锁显形）
   SECTION 04 章节行 · 纸面 1100px 加宽 · 锁定态 tg-hold 微字段
   门禁：英文提问 WAIT... WHO AM I? · 答 air 解锁 · 两次答错不同提示
   答对：剩余像素补全 + 色彩逐行显影 → 提问烟消云散 → 联系方式逐行显影
   注：信息明文占位，上线前接加密层/接口（解锁前 DOM 无明文） */

const CONTACTS = [
  {
    label: 'X',
    value: '@0x0_air',
    href: 'https://x.com/0x0_air',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: 'Discord',
    value: '@air_a.',
    href: '#',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
      </svg>
    ),
  },
  {
    label: 'Gmail',
    value: 'bitooair@gmail.com',
    href: 'mailto:bitooair@gmail.com',
    icon: <img src="/images/gmail.png" alt="" className="w-4 h-4" />,
  },
  {
    label: 'Github',
    value: 'github.com/0x0air',
    href: 'https://github.com/0x0air',
    icon: <Github className="w-4 h-4" />,
  },
  {
    label: 'Telegram',
    value: 't.me/Xttt77',
    href: 'https://t.me/Xttt77',
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
      </svg>
    ),
  },
];

const Q_TEXT = 'WAIT... WHO AM I?';

const ContactSection = () => {
  const sectionRef = useRef(null);
  const paperRef = useRef(null);
  const [burst, setBurst] = useState(false);        // 滚入视口触发
  const [burstDone, setBurstDone] = useState(false); // 纸张显形 & 头像拼合启动
  const [unlocked, setUnlocked] = useState(false);   // 答对
  const [smoke, setSmoke] = useState(false);         // 提问烟消云散中
  const [revealed, setRevealed] = useState(false);   // 信息行显影
  const [error, setError] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [value, setValue] = useState('');

  // 滚入视口 → 触发入场（一次性）
  useEffect(() => {
    if (burst) return undefined;
    let done = false;
    const check = () => {
      if (done) return;
      const el = sectionRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8 && r.bottom > 0) {
        done = true;
        setBurst(true);
        window.removeEventListener('scroll', check);
        clearInterval(id);
      }
    };
    const id = setInterval(check, 300); // 须先于 check() 调用，否则首帧可见时 TDZ 崩溃
    window.addEventListener('scroll', check, { passive: true });
    check();
    return () => {
      window.removeEventListener('scroll', check);
      clearInterval(id);
    };
  }, [burst]);

  // 纸张显形后启动头像拼合
  useEffect(() => {
    if (!burst) return undefined;
    const t = setTimeout(() => setBurstDone(true), 850);
    return () => clearTimeout(t);
  }, [burst]);

  const tryU = () => {
    if (value.trim().toLowerCase() === 'air') {
      setUnlocked(true);
      setSmoke(true);
      // 烟消云散需等最后字符完成（交错延迟 0.3s + 过渡 0.65s ≈ 0.95s），1.6s 后才换显影，避免硬切
      setTimeout(() => setRevealed(true), 1600);
    } else {
      setAttempts((a) => a + 1);
      setError(true);
      setTimeout(() => setError(false), 1100);
    }
  };

  return (
    <section className="contact-section pt-20 pb-32 px-8" ref={sectionRef}>
      <style>{`
        .ct-topline {
          max-width: 1100px; margin: 0 auto 26px;
          display: flex; justify-content: space-between; align-items: baseline;
          font-family: 'Goldman', sans-serif; font-size: .72rem; letter-spacing: .3em;
          text-transform: uppercase; color: #6b7280;
          border-bottom: 2px solid #2d3436; padding-bottom: 10px;
        }
        .contact-fuse { max-width: 1100px; margin: 0 auto; }
        .fuse-paper {
          position: relative; background: #fffdf5; border-radius: 6px;
          border: 1px solid rgba(45,52,54,.12); padding: 0;
          box-shadow: 0 18px 44px rgba(60,42,10,.15);
          background-image: radial-gradient(circle at 90% 0%, rgba(210,155,58,.08), transparent 40%);
          overflow: hidden;
          opacity: 0; transform: scale(.97) translateY(10px);
          transition: opacity .8s ease, transform .8s cubic-bezier(.22,1,.36,1);
        }
        .fuse-paper.materialized { opacity: 1; transform: none; }
        .tg-head {
          display: flex; justify-content: space-between; align-items: center;
          border-bottom: 3px double #2d3436; padding: 16px 34px;
          background: rgba(210,155,58,.07);
        }
        .tg-word { font-family: 'Bungee', sans-serif; font-size: 1.25rem; color: #2d3436; letter-spacing: .08em; }
        .tg-formno { font-family: ui-monospace, Consolas, monospace; font-size: .7rem; color: #9ca3af; letter-spacing: .14em; }
        .tg-micro {
          display: flex; justify-content: space-between; gap: 14px; flex-wrap: wrap;
          padding: 10px 34px; border-bottom: 1px dashed rgba(45,52,54,.14);
          font-family: ui-monospace, Consolas, monospace; font-size: .62rem;
          color: #9ca3af; letter-spacing: .16em;
        }
        .tg-micro b { color: #6b7280; font-weight: 400; }
        .tg-stamp {
          position: absolute; top: 100px; right: 26px; width: 88px; height: 88px;
          display: flex; align-items: center; justify-content: center;
          border: 2px solid rgba(185,121,31,.38); border-radius: 50%;
          transform: rotate(-13deg); pointer-events: none;
          color: rgba(185,121,31,.52); text-align: center;
          font-family: ui-monospace, Consolas, monospace; font-size: .54rem;
          letter-spacing: .14em; line-height: 1.6;
        }
        .tg-stamp::before {
          content: ''; position: absolute; inset: 4px;
          border: 1px dashed rgba(185,121,31,.34); border-radius: 50%;
        }
        .tg-strip {
          height: 9px; margin-top: 16px;
          background: repeating-linear-gradient(135deg,
            #c05a4a 0 14px, #fffdf5 14px 26px,
            #4a6f8a 26px 40px, #fffdf5 40px 52px);
        }
        .tg-body {
          display: flex; align-items: center; gap: 16px;
          padding: 32px 34px 12px;
        }
        .tg-photo {
          flex-shrink: 0; width: 400px; display: flex; justify-content: center;
          border-right: 1px dashed rgba(45,52,54,.18); padding-right: 16px;
        }
        .tg-photo canvas { display: block; width: 400px; height: 400px; }
        .tg-side { flex: 1; min-width: 0; }
        .tg-gate { text-align: center; padding: 16px 14px 8px; }
        .tg-q {
          font-family: 'Bungee', sans-serif; font-size: 1.5rem; color: #2d3436;
          letter-spacing: .04em; margin-bottom: 22px; display: inline-block;
        }
        .tg-q .qch { display: inline-block; white-space: pre; transition: all .65s ease var(--sd, 0s); }
        .tg-gate.smoke .qch {
          opacity: 0; filter: blur(7px);
          transform: translate(var(--mx, 0), var(--my, -26px)) rotate(var(--mr, 0deg)) scale(1.15);
        }
        .tg-gate.smoke .tg-inputrow, .tg-gate.smoke .tg-cap { opacity: 0; filter: blur(5px); transition: all .55s ease; }
        .tg-inputrow {
          display: flex; justify-content: center; align-items: baseline; gap: 2px;
          margin: 0 auto; width: max-content; min-width: 220px; max-width: 100%;
          border-bottom: 2px solid rgba(45,52,54,.4); padding: 2px 6px 6px;
          transition: border-color .25s ease, opacity .55s ease, filter .55s ease;
        }
        .tg-inputrow:focus-within { border-bottom-color: #d29b3a; }
        .tg-input {
          flex: 1; min-width: 160px; background: transparent; border: none; outline: none;
          font-family: 'Goldman', sans-serif; font-size: 1rem; letter-spacing: .18em;
          color: #2d3436; text-transform: uppercase; text-align: center; padding: 2px 0;
          caret-color: #d29b3a;
        }
        .tg-dot {
          width: 7px; height: 7px; border-radius: 50%; background: #d29b3a;
          margin-left: 3px; align-self: center;
          animation: dotblink 1.1s steps(1) infinite;
        }
        @keyframes dotblink { 0%, 55% { opacity: 1; } 56%, 100% { opacity: 0; } }
        .tg-cap {
          display: flex; align-items: center; justify-content: center; gap: 7px;
          font-family: 'Goldman', sans-serif; font-size: .7rem; letter-spacing: .1em;
          color: #9ca3af; margin-top: 14px; transition: color .25s ease;
        }
        .tg-cap svg { width: 12px; height: 12px; color: #d29b3a; flex-shrink: 0; }
        .tg-cap-err { color: #c0392b; }
        .tg-cap-err svg { color: #c0392b; }
        .tg-hold {
          display: flex; justify-content: space-between; gap: 10px; flex-wrap: wrap;
          margin-top: 26px; padding: 9px 4px 0;
          border-top: 1px dashed rgba(45,52,54,.16);
          font-family: ui-monospace, Consolas, monospace; font-size: .6rem;
          color: #9ca3af; letter-spacing: .14em;
        }
        .tg-hold b { color: #9c7516; font-weight: 400; }
        .tg-shake { animation: tgshake .6s ease; }
        @keyframes tgshake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); } 45% { transform: translateX(7px); }
          70% { transform: translateX(-4px); } 90% { transform: translateX(3px); }
        }
        .tg-lines { padding: 14px 10px 18px; }
        .tg-line {
          display: flex; align-items: center; gap: 13px; padding: 10px 2px;
          border-bottom: 1px dashed rgba(45,52,54,.14); text-decoration: none;
          opacity: 0; transform: translateY(10px);
          transition: all .5s cubic-bezier(.22,1,.36,1);
        }
        .tg-lines.go .tg-line { opacity: 1; transform: none; }
        .tg-ico { color: #6b7280; display: flex; flex-shrink: 0; }
        .tg-lab { font-family: 'Goldman', sans-serif; font-weight: 700; font-size: .8rem; color: #2d3436; width: 76px; flex-shrink: 0; }
        .tg-val { font-family: 'Goldman', sans-serif; font-size: .84rem; color: #6b7280; word-break: break-all; }
        .tg-foot {
          padding: 12px 2px 0; font-family: ui-monospace, Consolas, monospace;
          font-size: .68rem; color: #9ca3af; letter-spacing: .18em; text-align: right;
        }
        @media (max-width: 860px) {
          .tg-body { flex-direction: column; }
          .tg-photo { border-right: none; border-bottom: 1px dashed rgba(45,52,54,.18); padding: 0 0 16px; width: auto; }
          .tg-photo canvas { width: 260px; height: 260px; }
        }
      `}</style>

      <div className="ct-topline">
        <span>Section 04</span>
        <span>Secure Channel</span>
      </div>
      <div className="contact-fuse">
        <div className={`fuse-paper ${burstDone ? 'materialized' : ''} ${burst && !burstDone ? 'converging' : ''}`} ref={paperRef}>
          <div className="tg-head">
            <span className="tg-word">CONTACT</span>
            <span className="tg-formno">FORM DL-9</span>
          </div>
          <div className="tg-micro" aria-hidden="true">
            <span>REF NO. <b>0X0A1R</b></span>
            <span>DATE <b>1973</b></span>
            <span>OPERATOR <b>ON DUTY</b></span>
          </div>
          <div className="tg-stamp" aria-hidden="true">
            PAR AVION
            <br />
            VIA AIR MAIL
            <br />
            · 73 ·
          </div>
          <div className="tg-body">
            <div className="tg-photo">
              <PixelPortrait started={burstDone} developed={unlocked} />
            </div>
            <div className="tg-side">
              {!revealed && (
                <div className={`tg-gate ${smoke ? 'smoke' : ''} ${error ? 'tg-shake' : ''}`}>
                  <div className="tg-q">
                    {Q_TEXT.split('').map((ch, i) => (
                      <span
                        key={i}
                        className="qch"
                        style={{
                          '--sd': `${(i % 6) * 0.06}s`,
                          '--mx': `${((i * 37) % 61) - 30}px`,
                          '--my': `${-18 - ((i * 29) % 26)}px`,
                          '--mr': `${((i * 53) % 41) - 20}deg`,
                        }}
                      >
                        {ch === ' ' ? '\u00A0' : ch}
                      </span>
                    ))}
                  </div>
                  <div className="tg-inputrow">
                    <span className="tg-input-wrap">
                      <input
                        className="tg-input"
                        aria-label="contact unlock input"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') tryU(); }}
                        disabled={unlocked}
                        autoComplete="off"
                        spellCheck="false"
                      />
                      {!unlocked && <span className="tg-dot" aria-hidden="true"></span>}
                    </span>
                  </div>
                  <div className={`tg-cap ${error ? 'tg-cap-err' : ''}`}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                      <rect x="4" y="11" width="16" height="9" rx="2" />
                      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                    </svg>
                    <span>
                      {error
                        ? attempts === 1
                          ? 'HINT — YOU JUST SAW MY NAME'
                          : 'HINT — REFRESH THE PAGE TO FIND IT'
                        : 'ENCRYPTED — ANSWER TO REVEAL'}
                    </span>
                  </div>
                  <div className="tg-hold" aria-hidden="true">
                    <span>STATUS <b>AWAITING VERIFICATION</b></span>
                    <span>FILE ACCESS <b>GRANTED ON ANSWER</b></span>
                  </div>
                </div>
              )}
              {revealed && (
                <div className="tg-lines go">
                  {CONTACTS.map((c, i) => (
                    <a
                      key={i}
                      href={c.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="tg-line"
                      style={{ transitionDelay: revealed ? `${0.15 + i * 0.1}s` : '0s' }}
                    >
                      <span className="tg-ico">{c.icon}</span>
                      <span className="tg-lab">{c.label}</span>
                      <span className="tg-val">{c.value}</span>
                    </a>
                  ))}
                  <div className="tg-foot">SENT FROM THE DESK OF AIR · 73</div>
                </div>
              )}
            </div>
          </div>
          <div className="tg-strip" aria-hidden="true"></div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
